<template>
  <v-app id="inspire">
    <main-header></main-header>
    <mechanic-sidebar v-if="isMechanic" />
    <sidebar-menu v-else />
    <v-content>
      <v-container class="fill-height" fluid>
        <v-layout class="m-container" column>
          <!-- Content -->
          <div class="content" :class="{ pt: $vuetify.breakpoint.smAndDown }">
            <router-view />
          </div>
        </v-layout>
      </v-container>
    </v-content>
    <notifications-menu v-if="showNotifications" />
    <image-viewer />
  </v-app>
</template>

<script>
import store from '@/store';
import MainHeader from '@/components/layout/MainHeader.vue';
import SidebarMenu from '@/components/layout/SidebarMenu.vue';
import ImageViewer from '@/components/layout/ImageViewer.vue';
import NotificationsMenu from '@/components/layout/notifications/NotificationsMenu.vue';
import MechanicSidebar from '@/components/mechanic/MechanicSidebar.vue';

export default {
  name: 'MainLayout',
  async beforeRouteEnter(to, from, next) {
    if (!localStorage.getItem('token')) {
      store.commit('auth/setAuthenticated', false);
      localStorage.removeItem('me');
      store.commit('global/setRole', null, { root: true });
    }
    if (store.getters['auth/isAuthenticated']) {
      next();
    } else {
      next('/auth/login');
    }
  },
  props: {
    source: String,
  },
  components: {
    MainHeader,
    SidebarMenu,
    ImageViewer,
    NotificationsMenu,
    MechanicSidebar,
  },
  computed: {
    showNotifications() {
      return (
        this.$can('auto_notification_insurance_inspection') || // eslint-disable-line
        this.$can('auto_notification_internal_maintenance')
      );
    },
    isMechanic() {
      return this.$store.getters['global/getRole'] === 'mechanic';
    },
  },
};
</script>

<style lang="scss">
.content {
  margin-top: 48px;
}
</style>
